import React, { useMemo } from 'react';
import Card from 'react-bootstrap/Card';
import EditableParam from './EditableParam';
import { matchesSearch } from './UserAttributeSection';

type Props<M> = {
  meta: M;
  onChange: (meta: M) => void;
  // shows only the tiers (BRONZE / SILVER / GOLD) matching it
  search?: string;
};

export default function MetaFragmentsEditor({
  meta,
  onChange,
  search = '',
}: Props<{ BRONZE: string; SILVER: string; GOLD: string }>) {
  const { BRONZE, SILVER, GOLD } = useMemo(
    () => ({
      BRONZE: meta?.BRONZE,
      SILVER: meta?.SILVER,
      GOLD: meta?.GOLD,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // @ts-ignore
  const handleChangeAmount = (key: string) => (event) => {
    const { value } = event.target;
    if (onChange) {
      onChange({ ...meta, [key]: value });
    }
  };

  const tiers = [
    { key: 'BRONZE' as const, placeholder: BRONZE },
    { key: 'SILVER' as const, placeholder: SILVER },
    { key: 'GOLD' as const, placeholder: GOLD },
  ].filter(({ key }) => matchesSearch(key, search));

  return (
    <Card>
      <Card.Body>
        {tiers.length > 0 ? (
          tiers.map(({ key, placeholder }) => (
            <EditableParam
              key={key}
              title={key}
              value={meta?.[key]}
              onChange={handleChangeAmount(key)}
              placeholder={placeholder}
            />
          ))
        ) : (
          <i>No match</i>
        )}
      </Card.Body>
    </Card>
  );
}
